
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categorie/nieuws",
      function () {
        return require("private-next-pages/categorie/nieuws.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categorie/nieuws"])
      });
    }
  